import { gql }  from '@apollo/client';

const SET_SECONDARY_INSURANCE = gql`
  mutation($memberId: ID!, $secondaryInsurance: SecondaryInsuranceInput!) {
    setSecondaryInsurance(
      memberId: $memberId,
      secondaryInsurance: $secondaryInsurance
    ) {
      success
      errors
    }
  }
`;

export default SET_SECONDARY_INSURANCE;
